import React, {useState} from "react";
import {url} from "../utils/UrlsUtil";
import "../../style/common/header/_header.scss";
import {Link} from "react-router-dom";
import GoodsSearch from "../goods/GoodsSearch.tsx";
import {Image} from "react-bootstrap";
import {post} from "../utils/FetchUtil.ts";
import {useAuth} from "../components/context/AuthProvider.tsx";
import {popConfirm} from "../utils/MessageUtil.ts";

interface HeaderProps{
    breadcrumb_list: string[];
    search?: GoodsListSearchDto;
}

const Header:React.FC<HeaderProps> = ({
    breadcrumb_list = [],
    search
  }) => {
    const { loginDto } = useAuth();
    const { logout } = useAuth();
    const onClickLogout = () => {
        popConfirm(
            "ログアウトします。よろしいですか？", () => {
                post<LoginInfoDto>({
                    action: "/api/login/logout",
                    data: {},
                })
                    .then(() => {
                        logout();
                    })
                    .catch((reason) => {
                        console.log(reason);
                        logout();
                    })
                    .finally(() => {});
        })
    }
    // 1. チェック状態を管理するstateを定義 (初期値: false)
    const [isChecked, setIsChecked] = useState(false);

    // 2. チェックボックスの状態が変更されたときに呼ばれる関数
    const handleOnChange = () => {
        setIsChecked(!isChecked); // 現在の値の反対の値をセットする
    };
    const closeMenu = () => {
        setIsChecked(false);
    }
    return (
        <>
        <div id="pageHeader" className="row gx-0">
            <div className="col-12 text-center geeva-logo-area">
                <div className="menu-wrapper">
                    <input type="checkbox" id="menu-toggle" hidden  checked={isChecked} onChange={handleOnChange} />

                    <label className="menu-icon" htmlFor="menu-toggle">
                        <span></span>
                        <span></span>
                        <span></span>
                    </label>
                    <div className="overlay" onClick={closeMenu}></div>
                    <nav className="menu">
                        <div className={"menu-header"}>MENU</div>
                        <ul>
                            <li><Link to="/">HOME</Link></li>
                            {/*年末年始感謝セールが終了したので非表示にする*/}
                            <li style={{display: "none"}}><Link to="/2025oseibo/">2025年年末年始特集</Link></li>
                            <li><Link to="/lottery/">くじギフトの紹介</Link></li>
                            {loginDto?.logged_in && <>
                                <li><Link to="/goods/list/egift/" onClick={closeMenu}>eGift一覧</Link></li>
                                <li><Link to="/goods/list/eselect/" onClick={closeMenu}>eSelect一覧</Link></li>
                                <li><Link to="/mypage/">MY PAGE</Link></li>
                                <li><Link to="/member/resign">退会</Link></li>
                            </>}
                        </ul>
                        {search != null &&
                            <GoodsSearch search={search} closeMenu={closeMenu} />
                        }
                    </nav>
                </div>
                <div className="logo-img">
                    <img src={url("/images/logo/geeva_logo.png")}/>
                </div>
                {loginDto?.logged_in && <span className="loggedin-header-right">
                    <Link to="/member/update" className="login-name">{loginDto.login_name} 様</Link>
                    <Link to="/mypage/"><Image src={"/images/icon/mypage_icon.png"} fluid={true}></Image></Link>
                    <span className="logout-btn" onClick={onClickLogout}><Image src={"/images/icon/logout_icon.png"} fluid={true}></Image></span>
                </span>}
                {!loginDto?.logged_in && <span className="loggedin-header-right">
                    <Link to="/login/"><Image src={"/images/icon/login_icon.png"} fluid={true}></Image></Link>
                </span>}
            </div>
        </div>
        <div id={"pageBreadcrumb"} className={"row gx-0"}>
            <div className="col-12">
                <div className="d-flex justify-content-start breadcrumb-area">
                    {breadcrumb_list && breadcrumb_list.length != 0 &&
                      <nav aria-label="breadcrumb" style={{padding: '0 1rem'}}>
                        <ol className="breadcrumb">
                          <li className="breadcrumb-item"><Link to="/">HOME</Link></li>
                            {breadcrumb_list.map((value, index) =>
                                <li key={`breadcrumb-item_key${index}`} className={`breadcrumb-item${index == breadcrumb_list.length -1 ? ' active' : ''}`} aria-current="page">{value}</li>)
                            }
                        </ol>
                      </nav>
                    }
                </div>
            </div>
        </div>
        </>
    );
};
export default Header;